/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote-icon': {
    width: 10,
    height: 8,
    viewBox: '0 0 10 8',
    data: '<defs><path pid="0" d="M5.303.465a.5.5 0 0 1 .09.992l-.09.008h-1.61l.011.04c.418 1.53-.194 2.74-1.731 3.555l-.239.118 1.921 1.458a.5.5 0 0 1 .144.624l-.047.077a.498.498 0 0 1-.623.144l-.076-.048-2.62-1.99a.5.5 0 0 1 .14-.872C2.5 3.92 3.139 2.981 2.699 1.62a.5.5 0 0 1-.025-.154H.5a.5.5 0 0 1-.09-.993L.5.465h4.804zm2.35 1.346a.5.5 0 0 1 .492.41l.008.09v1.346l1.348.001a.5.5 0 0 1 .09.992l-.09.008H8.153v1.348a.5.5 0 0 1-.992.09l-.008-.09V4.657l-1.348.001a.5.5 0 0 1-.09-.992l.09-.008h1.348V2.31a.5.5 0 0 1 .5-.499z" id="svgicon-quote-icon-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-quote-icon-a" fill-rule="evenodd"/>'
  }
})
